export default class Ids {
  /**
   * Keys constructor.
   * @param {?string} prefix
   */
  constructor(prefix = null) {
    this._positive = 1;
    this._negative = -1;
    this._prefix = prefix;
  }

  /**
   * Get next positive key.
   * @returns {string}
   */
  nextNegative() {
    return this._prefixedValue(this._negative--);
  }

  /**
   * Get next positive key.
   * @returns {string}
   */
  nextPositive() {
    return this._prefixedValue(this._positive++);
  }

  /**
   * Get current negative key.
   * @returns {string}
   */
  currentNegative() {
    return this._prefixedValue(this._negative);
  }

  /**
   * Get current positive key.
   * @returns {string}
   */
  currentPositive() {
    return this._prefixedValue(this._positive);
  }

  /**
   * Reset internal keys.
   */
  reset() {
    this._positive = 1;
    this._negative = -1;
  }

  /**
   * Get prefixes value.
   * @param {string|number} value
   * @returns {string}
   * @private
   */
  _prefixedValue(value) {
    if (this._prefix) {
      return String(this._prefix) + String(value);
    }

    return String(value);
  }
}
